import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AnimatedAccordion from 'products/nomad_insurance/components/AnimatedAccordion';
import { SectionContainer, SectionHeading, Toggle } from './styled';

const Section = ({ heading, children, hideOverflow = true }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <SectionContainer $hideOverflow={hideOverflow}>
      <SectionHeading>
        {heading}
        <Toggle onClick={() => setIsOpen(!isOpen)} $isOpen={isOpen} />
      </SectionHeading>

      <AnimatedAccordion isOpen={isOpen} marginTop="16px" hideOverflow={hideOverflow}>
        {children}
      </AnimatedAccordion>
    </SectionContainer>
  );
};

Section.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  hideOverflow: PropTypes.bool
};

export default Section;
